// src/theme/shadows.js

// Defining custom soft shadows suited for clean, modern cards and surfaces
export const shadows = [
  'none',
  // 1
  '0px 1px 3px rgba(15, 23, 42, 0.05), 0px 1px 2px rgba(15, 23, 42, 0.03)',
  // 2
  '0px 2px 4px rgba(15, 23, 42, 0.06), 0px 1px 2px rgba(15, 23, 42, 0.04)',
  // 3
  '0px 4px 6px rgba(15, 23, 42, 0.05), 0px 10px 15px -3px rgba(15, 23, 42, 0.03)',
  // 4 (Used for default Cards)
  '0px 4px 6px -1px rgba(15, 23, 42, 0.05), 0px 10px 15px -3px rgba(15, 23, 42, 0.03)',
  // 5 (Used for hovered Cards / Elevation lift)
  '0px 10px 20px -3px rgba(15, 23, 42, 0.08), 0px 4px 12px -2px rgba(15, 23, 42, 0.03)',
  // 6
  '0px 10px 15px -3px rgba(15, 23, 42, 0.1), 0px 4px 6px -2px rgba(15, 23, 42, 0.05)',
  // 7
  '0px 20px 25px -5px rgba(15, 23, 42, 0.1), 0px 10px 10px -5px rgba(15, 23, 42, 0.04)',
  // 8 (Used for Dialogs)
  '0px 25px 50px -12px rgba(15, 23, 42, 0.25)',
  // 9 - 24 (fillers to satisfy MUI shadows array requirements)
  '0px 2px 5px rgba(0, 0, 0, 0.05)',
  '0px 2px 10px rgba(0, 0, 0, 0.05)',
  '0px 3px 12px rgba(0, 0, 0, 0.05)',
  '0px 4px 15px rgba(0, 0, 0, 0.05)',
  '0px 5px 18px rgba(0, 0, 0, 0.05)',
  '0px 6px 20px rgba(0, 0, 0, 0.05)',
  '0px 7px 22px rgba(0, 0, 0, 0.05)',
  '0px 8px 24px rgba(0, 0, 0, 0.05)',
  '0px 9px 26px rgba(0, 0, 0, 0.05)',
  '0px 10px 28px rgba(0, 0, 0, 0.05)',
  '0px 11px 30px rgba(0, 0, 0, 0.05)',
  '0px 12px 32px rgba(0, 0, 0, 0.05)',
  '0px 13px 34px rgba(0, 0, 0, 0.05)',
  '0px 14px 36px rgba(0, 0, 0, 0.05)',
  '0px 15px 38px rgba(0, 0, 0, 0.05)',
  '0px 16px 40px rgba(0, 0, 0, 0.05)',
];
